import { environment } from 'src/environments/environment';
type EnvKey = 'dev' | 'test_old'|'test' | 'stage' | 'prod';
// Status IDs for each environment
const statusConfig: Record<EnvKey, { submit: number; draft: number ; 
  cancelled: number; completed: number }> = {
  dev:   { submit: 4, draft: 13 , cancelled :5,completed :11},
  test_old:  { submit: 2, draft: 8 , cancelled :3 ,completed : 7},
  test: { submit: 4, draft: 13 , cancelled :5,completed :11},
  stage: { submit: 4, draft: 13,cancelled :5,completed : 11 },
  prod:  { submit: 4, draft: 13, cancelled :5 ,completed : 11}
};

// SummaryType values for each environment
const summaryTypeConfig: Record<EnvKey, Record<string, number>> = {
    dev: {
    EQM: 1,
    JobPlanParts: 2,
    MWOHeader: 3,
    JobPlanLabor: 4,
    EPL: 5,
    PMRoutes: 6,
    PreventativeMaintenance: 7,
    PMAssociations: 8,
    ObsoleteItems: 9,
  },
  test_old: {
    JobPlanParts: 1,
    MWOHeader: 2,
    JobPlanLabor: 3,
    EQM: 4,
    PreventativeMaintenance: 5,
    PMRoutes: 6,
    PMAssociations: 7,
    EPL: 8,
    ObsoleteItems: 9,
  },
   test: {
    EQM: 1,
    JobPlanParts: 2,
    MWOHeader: 3,
    JobPlanLabor: 4,
    EPL: 5,
    PMRoutes: 6,
    PreventativeMaintenance: 7,
    PMAssociations: 8,
    ObsoleteItems: 9,
  },
  stage: {
    EQM: 1,
    JobPlanParts: 2,
    MWOHeader: 3,
    JobPlanLabor: 4,
    EPL: 5,
    PMRoutes: 6,
    PreventativeMaintenance: 7,
    PMAssociations: 8,
    ObsoleteItems: 9,
  },
  prod: {
    EQM: 1,
    JobPlanParts: 2,
    MWOHeader: 3,
    JobPlanLabor: 4,
    EPL: 5,
    PMRoutes: 6,
    PreventativeMaintenance: 7,
    PMAssociations: 8,
    ObsoleteItems: 9,
  }
};

// Add request priority config
const requestPriorityConfig: Record<EnvKey, { urgent: number; high: number; medium: number }> = {
  dev:   { urgent: 1, high: 2, medium: 3 },
  test_old:  { urgent: 1, high: 3, medium: 4 },
  test:  { urgent: 1, high: 2, medium: 3 },
  stage: { urgent: 1, high: 2, medium: 3 },
  prod:  { urgent: 1, high: 2, medium: 3 }
};

export function getAcdEnvConfig() {
  const env = (environment.envName || 'dev').toLowerCase() as EnvKey;
  // fallback to 'dev' if env is not found
  return {
    status: statusConfig[env] || statusConfig['dev'],
    summaryType: summaryTypeConfig[env] || summaryTypeConfig['dev'],
    requestPriority: requestPriorityConfig[env] || requestPriorityConfig['dev']
  };

}